// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./channels"  // Action Cable for real-time Turbo Streams
import "./controllers"
import "./number_inputs"  // a wheel/trackpad scroll must never change a number field
import "./auth/login"
import "./auth/signup"
import "./auth/forgot_password"
import "./auth/add_password"
import "./auth/setup_password"
import "./auth/reset_password"

// Password visibility toggle
window.togglePasswordVisibility = function(inputId, button) {
  const input = document.getElementById(inputId)
  const icon = button.querySelector('i')

  if (input.type === 'password') {
    input.type = 'text'
    icon.classList.remove('fa-eye')
    icon.classList.add('fa-eye-slash')
  } else {
    input.type = 'password'
    icon.classList.remove('fa-eye-slash')
    icon.classList.add('fa-eye')
  }
}

